<template>
    <div v-if="products.length > 0" v-loading="loading" class="featured-products">
        <h3 class="text-center text-base xl:text-xl">Featured Products</h3>
        <el-carousel :autoplay="true" :interval="6000" :loop="true" trigger="click" :arrow="products.length > 1 ? 'hover' : 'never'" indicator-position="none">
            <el-carousel-item v-for="item in products" :key="`product-${item.id}`">
                <p class="mb-2 text-center text-sm">{{ item.name }}</p>
                <a :href="route('studio.shop.item', { studioSlug: studio.slug, product: item.id })" :title="item.name">
                    <responsive-image type="product" :media="item.photo" :title="item.name" sizes="300px"></responsive-image>
                </a>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    import axios from '@/axios';
    import ResponsiveImage from '@/components/ResponsiveImage.vue';

    export default {
        name: 'FeaturedProducts',
        components: {
            ResponsiveImage,
        },
        filters: {},
        mixins: [],
        props: {
            studio: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                loading: true,
                products: [],
            };
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.loading = true;
                axios.get(route('studio.featured.products', { studioSlug: this.studio.slug })).then((response) => {
                    this.products = response.data.data.products;
                    this.loading = false;
                });
            },
        },
    };
</script>

<style>
    .featured-products .el-carousel__container {
        height: 32rem;
    }

    @media (min-width: 1024px) {
        .featured-products .el-carousel__container {
            height: 24rem;
        }
    }
</style>
